<template>
  <el-scrollbar class="crm-operate-log">
    <el-timeline v-infinite-scroll="getList" :infinite-scroll-disabled="disabled" style="padding-right: 15px; padding-bottom: 0px">
      <el-timeline-item v-for="(item, index) in list" :key="index" :timestamp="item.createTimeStr" placement="top" color="#409EFF">
        <el-card>
          <div class="content">
            <span>{{item.createUserName}}{{" "}}</span>
            <span v-if="item.isParse">
                <span v-html="item.contentObject.startContent"></span>
                <el-link
                  type="primary"
                  :underline="false"
                  @click="toDetail(item.contentObject.targetId, item.contentObject.targetType)">
                  {{ item.contentObject.targetName }}
                </el-link>
                <span v-html="item.contentObject.endContent"></span>
            </span>
            <span v-else class="content" v-html="item.content"></span>
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <p v-if="loading" class="tip">加载中...</p>
    <p v-if="noMore" class="tip">{{list.length > 0 ? "没有更多了" : "暂无数据"}}</p>
  </el-scrollbar>
</template>

<script>
import {listOperateLog} from "@/api/crm/opereteLog";
import {businessTargetTypeToPath} from "@/utils/crm";

export default {
  name: "operateLogList",
  props: {
    targetId: {},
    targetType: {}
  },
  data() {
    return {
      loading: false,
      noMore: false,
      list: [],
      // 查询参数
      queryParams: {
        pageNum: 0,
        pageSize: 10,
        businessKey: null,
        businessType: null
      }
    };
  },
  created() {
    this.queryParams.businessKey = this.targetId;
    this.queryParams.businessType = this.targetType;
    this.refresh();
  },
  watch: {
    targetId (val) {
      if (val !== this.queryParams.businessKey) {
        this.queryParams.businessKey = val;
        this.refresh();
      }
    },
    targetType (val) {
      if (val !== this.queryParams.businessType) {
        this.queryParams.businessType = val;
        this.refresh();
      }
    }
  },
  computed: {
    disabled () {
      return this.loading || this.noMore
    }
  },
  methods: {
    getList() {
      if (!this.queryParams.businessKey || !this.queryParams.businessType) {
        return;
      }
      this.loading = true
      this.queryParams.pageNum++
      listOperateLog(this.queryParams).then(response => {
        let list = response.rows.map(item => {
          return this.parseContent(item);
        })
        this.list = this.list.concat(list);
        if (!response.rows || response.rows.length < this.queryParams.pageSize) {
          // 查完了
          this.noMore = true
        }
        this.loading = false
      }).catch(error => {
        this.loading = false
        this.noMore = true
      });
    },
    refresh () {
      if (!this.queryParams.businessKey || !this.queryParams.businessType) {
        return;
      }
      this.queryParams.pageNum = 0
      this.list = []
      this.noMore = false
      this.getList()
    },
    parseContent(log) {
      if (log && log.content && log.content.length > 0 && log.content.charAt(0) === '{') {
        log.contentObject = JSON.parse(log.content);
        // {"log":"将销售线索转为商机,转换后商机名称: #targetName#","targetId":"7","targetName":"好商机","targetType":"business"}
        if (log.contentObject) {
          log.isParse = true
          if (log.contentObject.log) {
            let index = log.contentObject.log.indexOf("#targetName#");
            if (index > -1) {
              log.contentObject.startContent = log.contentObject.log.substring(0, index);
              log.contentObject.endContent = log.contentObject.log.substring(index + 12);
            }
          }
        }
      }
      return log;
    },
    /** 详细按钮操作 */
    toDetail(targetId, targetType) {
      window.open("/crm/" + businessTargetTypeToPath(targetType) + "/detail/" + targetId, "_blank")
    }
  }
};
</script>

<style lang='scss'>
.el-scrollbar {
  height: 100%;
}
.crm-operate-log {
  .type-title{
    word-break: break-all;
    line-height: 1em;
  }
  .content {
    word-break: break-all;
    line-height: 1.5em;
    .el-link{
      vertical-align: top;
      height: 16px;
      margin-top: 1px;
    }
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .tip{
    text-align: center;
    color: #909399;
    font-size: 14px;
  }
}
</style>

